import { computed } from 'vue';

import { CurrencyFormatter } from '../utils/CurrencyFormatter';
import i18n from '@/config/i18n';
import { info } from '@/store/mainInfo';
import { getFromCache } from '@/utils/helpers';

const formatters = {};

/**
 * @param {string} locale
 * @param {string} currency
 * @return {CurrencyFormatter}
 */
const getFormatter = (locale, currency) => getFromCache(
  () => new CurrencyFormatter(locale, currency),
  `${locale}_${currency}`,
  formatters,
);

/**
 * @param {number} value
 * @param {string} locale
 * @param {string} currency
 * @return {string}
 */
export const formatCurrency = (value, locale, currency) => getFormatter(locale, currency)
  .format(value);

export const currentCurrencySymbol = computed(
  () => getFormatter(i18n.global.locale.value, info.value.currency).symbol,
);

export const formatCurrencyByDefault = (value) => formatCurrency(
  value,
  i18n.global.locale.value,
  info.value.currency,
);
